import React, { } from "react";
import { Modal } from "antd";
import { useDispatch } from "react-redux";
import NoSubCompareInput from "./NoSubCompareInput";
import { setVisibleInsightsModal } from "../../../store/components/Reports.slice";

function NoSubCompareResultModal({ data }) {
    const dispatch = useDispatch();

    return (
        <Modal
            width={700}
            height={500}
            centered
            className="report--insights--nosubsmodal"
            open={data.visible}
            title={null}
            footer={null}
            onCancel={() => {
                dispatch(setVisibleInsightsModal({
                    data: null,
                    visible: false
                }));
            }}
        >
            <NoSubCompareInput className="result" />
        </Modal>
    );
}

export default NoSubCompareResultModal;
